<div class="form-group">
    <!-- e-float-input and e-control-wrapper are used for styling. Adjust class names based on your CSS. -->
    <div class="e-float-input e-control-wrapper" [ngClass]="{'e-error': showError}">
        <!-- Conditionally render input or textarea based on the isTextArea flag -->
         @if (!isTextArea) {
            <input [formControl]="control"
                   [attr.type]="type" 
                   [id]="label" 
                   [name]="label" 
                   autocomplete="off" 
                   [attr.required]="isRequired ? true : null" 
                   [attr.pattern]="pattern ? pattern : null">
         } @else{
            <textarea [formControl]="control" 
                      [id]="label" 
                      [name]="label" 
                      [attr.required]="isRequired ? true : null"></textarea>
         }
        <span class="e-float-line"></span>
        <!-- Label is associated with the input or textarea by the 'for' attribute -->
        <label class="e-float-text e-label-top" [attr.for]="label">{{ label }}</label>
    </div>
    <!-- Error message section that appears only if there's an error and the control has been touched -->
     @if(showError)
     {
        <div class="error-message">
            <label class="e-error" [attr.for]="label">{{ errorMessage }}</label>
        </div>    
     }
</div>
